<template>
<div class="container-fluid">
	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
	    <div class="col-12">
			<h1>Trashed Notes</h1>
		</div>
		<div class="col-12">
			<div class="card table-responsive">
    			<table class="table mb-0">
    				<thead>
    					<th></th>
    					<th>Client</th>
    					<th>Note On</th>
    					<th>Preview</th>
    					<th>Deleted</th>
    					<th></th>
    				</thead>

    				<tr v-for="note in notes">
    					<td>
    						<input type="checkbox" :value="note.id" v-model="ids">
    					</td>
    					<td>
    						<span v-html="note.noteable && note.noteable.client ? note.noteable.client.name : '<em>unknown client</em>'" />
    					</td>
    					<td>
							<template v-if="note.noteable">
								<span v-html="note.noteable_type == 'App\\Group' ? '<em>Unknown group</em>' : '<em>unknown physician</em>'" />
							</template>
    					</td>
    					<td>
    						{{ note.body.substring(0, 40) + '...' }}
    					</td>
    					<td>
    						<span v-html="moment(note.deleted_at).format('MMM D, YYYY')" class="text-gray-500" />
    					</td>
    					<td>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Put Back'" @click="restoreItems(note.id)"><i class="fal fa-trash-undo text-gray-500"></i></button>
    						<button class="btn btn-light btn-sm" v-tooltip.bottom="'Permadelete'" @click="deleteItems(note.id)"><i class="fal fa-times-circle text-gray-500"></i></button>
    					</td>
    				</tr>

    				<tr>
    					<td>
    						<input type="checkbox" @click="toggleAll()">
    					</td>
    					<td colspan="5">
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="restoreItems()"><i class="fal fa-trash-undo mr-1"></i>Restore Items</button>
    						<button class="btn btn-primary" :disabled="ids.length < 1" @click="deleteItems()"><i class="fal fa-times-circle mr-1"></i>Permanently Delete</button>
    					</td>
    				</tr>
    			</table>
    		</div>
        </div>
    </div>
</div>	

</template>

<script>
	import BreadcrumbsManager from '../../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				data_loaded: false,
				notes: null,

				ids: [],
			}
		},

		created() {
			this.fetchTrashedPhysicianNotes();
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Trashed Items', to: { name: 'admin.trashed.notes'} },
	            { text: 'Notes', to: { name: ''} },
        	]);
		},


		methods: {
			deleteItems(id) {
				let ids = id ? [id] : this.ids;
				Swal.fire({
					title: 'Are you sure?',
					text: 'You will *really* not be able to recover the item(s)',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonText: 'Delete',
					cancelButtonText: 'Keep',
					animation: false,
				}).then((result) => {
					if (result.value) {
						this.data_loaded = false;
						axios.post('/api/notes/trashed/delete', { ids: ids }).then(({data}) => {
							Swal.fire({
			                    toast: true,
			                    position: 'top-end',
			                    showConfirmButton: false,
			                    timer: 3000,
			                    icon: 'success',
			                    title: 'Items deleted',
			                });
			                this.fetchTrashedPhysicianNotes();					
						});
					}
				});
			},

			fetchTrashedPhysicianNotes() {
				axios.get('/api/notes/trashed').then(({data}) => {
					this.notes = data;
					this.data_loaded = true;
				})
			},

			restoreItems(id) {
				let ids = id ? [id] : this.ids;
				this.data_loaded = false;
				axios.post('/api/notes/trashed/restore', { ids: ids }).then(({data}) => {
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Items restored',
	                });
	                this.fetchTrashedPhysicianNotes();					
				});
			},

			toggleAll() {
				if (this.ids.length > 0) {
					this.ids = [];
				} else {
					this.ids = this.notes.map(note => note.id);
				}
			}
		},
	}
</script>